import React, {Component, Fragment} from 'react';
import {_addNotification, _addNotificationError} from '../../../server/util';
import {declinedReasonList} from './schoolLunchBreakfastModal'
import {postWithHeaders} from "../../../server/actionsParent";
import moment from 'moment';
import { Trans } from 'react-i18next';

class SummaryReport extends Component{
    constructor(props){ 
        super(props);
        this.state={
            appData:{},
            districtStatus:this.props.isDistrict
        }
        this.saveLunchBreakfast=this.saveLunchBreakfast.bind(this);
        this.formatReqObj=this.formatReqObj.bind(this);        
    }
    componentDidMount=()=>{
        this.formatReqObj();
    }
    formatReqObj=()=>{
      const{districtStatus}=this.state;
        let reqBody={};
      reqBody.date=moment().format('MMDDYYYY');
      reqBody.status="pending";
      if(!districtStatus){
      reqBody.mealSchoolId=this.props.lunchObj.mealSchoolId;
    }
      reqBody.prmyParentEmail=sessionStorage.getItem('loggedInUserInfo');
      reqBody.schoolYear=this.props.schoolInfo.sessionYear;
      let persons=[];
      this.props.lunchObj.persons.map((person,p)=>{
        person.assistancePrograms=this.props.lunchObj.assistancePrograms;			
        persons.push(person)
      });
      let studentArray=[]
      this.props.lunchObj.studentList.map((student,p)=>{
        if(student.isSelected){
            if(student.liveUnderFosterCare===true){
              student.income=[];
            }
            if(this.props.lunchObj.isIncomeAfter===false){//user want to submitted without income details 
              student.income=[];
            }
          studentArray.push(student.studentRecId);
          persons.push(student)
        }            
      });
      reqBody.studentRecIds=studentArray.join(',');
      
      this.props.lunchObj.childList.map((child,p)=>{            
        persons.push(child)
      });
      this.props.lunchObj.adultList.map((adult,p)=>{            
        persons.push(adult)
      });
      reqBody.declinedReasonList=declinedReasonList.slice();
      reqBody.householdAppInfo=persons;

      this.setState({appData:reqBody});
    } 
    saveLunchBreakfast=()=>{
      const{districtStatus}=this.state;
      //console.log("districtStatus::::",districtStatus);
        let headers = {
          'Content-Type': 'application/json'
        };      
        let reqBody=this.state.appData;
      let _serStatusCode=''; 
     let url = ''
      if(districtStatus){
           url='/familyApplication?access_token='
      }else{
         url='/householdApplication?access_token='
      }
      //console.log("URL:::::::::::",url);
    postWithHeaders(`${url}`, JSON.stringify(reqBody),headers)
    .then((resp)=>{
      if (!resp.ok) {
          throw Error(resp.errorMessage);
      }    
      return resp.json();
    }).then(data => {
      if(data.statusCode===200){
          _addNotification(data.statusMessage,this.props.refNotify);
          this.props.jumpToStep(17);
      }else{
          _addNotificationError(data.statusMessage, this.props.refNotify);
      }
    // 
    }).catch(
      (error) => {
          console.log('Details not saved', error);
          _addNotificationError(<Trans>{`Please try again!`}</Trans>, this.props.refNotify);
      }
    );
  }
    render(){
        const {appData}= this.state;
        const { t, i18n } = this.props;
        return(<Fragment>
            <div className="row">
                <div className="col-md-12">
                    <div className="lowerPartTitle">
                        <h4><Trans>Summary</Trans></h4>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12" id="app-content" style={{padding: '10px', border: 'solid 4px #f1eff0'}}>
                {
                    this.props.buildHtmlUI(document.getElementById('app-content'),appData,t)
                }
                </div>        
            </div>   
            <div className="row device-inline-btn">
                <div className="col-md-4 col-xs-4 col-sm-4">
                    <button className="btn btn-next bg-color-4 btn-xs pull-left" onClick={(e)=>{
                        this.props.jumpToStep(15);
                    }}>
                        <Trans>Previous</Trans>
                    </button> 
                </div><div className="col-md-4 col-xs-4 col-sm-4 text-center">
                    <button className="btn btn-next btn-xs bg-color-1" onClick={(e)=>{
                        let element=document.createElement('div');
                        this.props.buildHtmlUI(element,(appData||{}));
                            let contents = element.innerHTML;
                            let frame1 = document.createElement('iframe');
                            frame1.name = "frame1";
                            frame1.style.position = "absolute";
                            frame1.style.top = "-1000000px";
                            document.body.appendChild(frame1);
                            let frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document : frame1.contentDocument;
                            frameDoc.document.open();
                            frameDoc.document.write('<html><head><title></title>');
                            frameDoc.document.write('</head><body>');
                            frameDoc.document.write(contents);
                            frameDoc.document.write('</body></html>');
                            frameDoc.document.close();
                            setTimeout( ()=> {
                                window.frames["frame1"].focus();
                                window.frames["frame1"].print();
                                document.body.removeChild(frame1);
                            }, 500);
                            return false;
                    }}><Trans>Print</Trans></button>
                </div>
                <div className="col-md-4 col-xs-4 col-sm-4">
                    <button className="btn btn-prev btn-xs bg-color-2 pull-right" 
                        onClick={(e)=>{
                            this.saveLunchBreakfast();   
                        }}><Trans>Submit</Trans>
                    </button>
                </div>
          </div>
        </Fragment>);
    }
}
export default SummaryReport


// WEBPACK FOOTER //
// ./src/components/Parent/SchoolLunchBreakfastProgram/summery.jsx